import SportsGroupList from 'components/specific/favorite-sports/sport-group-list'
import StoresGroupList from 'components/specific/favorite-stores/store-group-list'
import { GROUPS_MANAGEMENT_SPORTS, GROUPS_MANAGEMENT_STORES } from 'core/constants/translations/groups'
import { useOutsideClickListener } from 'core/hooks/useOutsideClickListener'
import { useTranslation } from 'react-i18next'

export interface SubheaderPopoverProps {
  groupClicked: string
  setIsOpen: (isOpen: boolean) => void
  isOpen: boolean
}
const SubheaderPopover = ({ groupClicked, setIsOpen, isOpen }: SubheaderPopoverProps) => {
  const { t } = useTranslation()
  const handleOutsideClick = (target: HTMLElement) => {
    // Without this guard, mouseup on the Dialog's "Yes" button (confirmation modal)
    // is detected as an outside click, causing the popover to unmount before the click handler fires.
    if (target.closest?.('.MuiDialog-root')) {
      return
    }

    if (target.id === 'shareButton' || target.id === 'shareButtonIcon') {
      return
    }

    if (target.id !== 'trigger-popover-sports' && target.id !== 'trigger-popover-stores') {
      setIsOpen(false)
    }
  }

  const outsideClickListenerRef = useOutsideClickListener(handleOutsideClick)

  return (
    <div className="mg-popover-groups" ref={outsideClickListenerRef}>
      <div className="mg-popover-groups-title">
        {groupClicked === 'sport' ? (
          <span>{t(GROUPS_MANAGEMENT_SPORTS)}</span>
        ) : (
          <span>{t(GROUPS_MANAGEMENT_STORES)}</span>
        )}

        <div
          className="mg-popover-groups-title__close"
          onClick={() => {
            setIsOpen(!isOpen)
          }}
        >
          <span className="material-icons-outlined notranslate">close</span>
        </div>
      </div>
      <div className="mg-popover-groups-body">
        {groupClicked === 'sport' ? <SportsGroupList /> : <StoresGroupList />}
      </div>
    </div>
  )
}

export default SubheaderPopover
